/**
 * Border radius tokens.
 *
 * Base radius of 4px matches the Figma swatch / control corner radius.
 * Larger steps (8/12/24) match cards, popovers and hero containers.
 */

export const radius = {
  none: 0,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 24,
  pill: 9999,
} as const;

/** Default component radius used by the MUI theme `shape.borderRadius`. */
export const baseRadius = radius.sm;

export type RadiusToken = keyof typeof radius;
